/////////////////////////
// Token Functions

export function getToken() {
  return localStorage.getItem("atk")
}

export function setToken(tk) { 
  localStorage.setItem("atk", tk)
}

export function getPayloadFromToken() {
  try {
    let tk = getToken()
    let tkArr = tk.split(".")
    if (tkArr.length !== 3) throw new Error()
    let payload = JSON.parse(atob(tkArr[1]))
    // console.log('user jwt payload:', payload)
    return payload
  } catch (err) {
    console.error(err, "Falha ao obter dados do usuário")
    return false
  }
}

export function isValid(tk) {
  if (tk) {
    try {
      let tkArr = tk.split(".")
      if (tkArr.length !== 3) throw new Error()
      let _header = atob(tkArr[0])
      let _payload = JSON.parse(atob(tkArr[1]))
      // console.log("payload", _payload)
      if (!("exp" in _payload)) throw new Error() 
    } catch (err) {
      console.error(err, "Falha na validação da sessão");
      return false;
    } 
    return true
  } else {
    console.error("Falha na validação da sessão");
    return false
  }
}

export function isExpired(tk) {
  let [ a, b, c ] = tk.split(".")
  let expiration = JSON.parse(atob(b)).exp * 1000
  // console.log(new Date(expiration))
  return expiration < Date.now()
}

